import { type Ref, computed, onBeforeUnmount, ref, watch } from 'vue'

import { useFocusWithin } from '@vueuse/core'

import { useActiveMenu } from './useActiveMenu'

export function useNavDropdown(
  id: string,
  triggerElement: Ref<HTMLElement | null | undefined>,
  onShow?: () => void,
) {
  const { activeMenu, isMenuActive, setActiveMenu, clearActiveMenu } =
    useActiveMenu()

  const isOpen = computed(() => activeMenu.value === id)

  let timeout: ReturnType<typeof setTimeout>

  function showMenu() {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      setActiveMenu(id)
      onShow?.()
    }, 150)
  }

  function hideMenu() {
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      clearActiveMenu()
    }, 150)
  }

  const withTransition = ref(true)
  watch(isMenuActive, () => {
    if (!isMenuActive.value) {
      withTransition.value = true
    }
  })

  const { focused } = useFocusWithin(triggerElement)
  watch(focused, (isFocused) => {
    if (!isFocused) {
      hideMenu()
    }
  })

  onBeforeUnmount(() => {
    clearTimeout(timeout)
  })

  return {
    isOpen,
    isMenuActive,
    showMenu,
    hideMenu,
    withTransition,
    focused,
  }
}
